import React from 'react'
import { Outlet } from 'react-router-dom'

const ViewSessionAvilabilityDetails = () => {
  return (
    <div>
        <Outlet/>
    </div>
  )
}

export default ViewSessionAvilabilityDetails